// DESIGN-SPEC §5.9 TabBar 自定义产品线图标
import type { SVGProps } from "react";

export function TeaLeafIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d="M12 21V11" />
      <path d="M12 11c0-4 3.2-6 6.5-6 0 4-3.2 6-6.5 6Z" />
      <path d="M12 8.5C12 5.5 9.5 4 6.8 4c0 3 2.5 4.5 5.2 4.5Z" />
    </svg>
  );
}

export function MoleculeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <circle cx="8" cy="9" r="2.5" />
      <circle cx="16" cy="7" r="2.5" />
      <circle cx="13" cy="16" r="2.5" />
      <path d="m10.2 10.6 1.6 3" />
      <path d="m14.9 8.9-1 4.6" />
    </svg>
  );
}
